import { render, staticRenderFns } from "./bcsz.vue?vue&type=template&id=4b9f1594&"
import script from "./bcsz.vue?vue&type=script&lang=js&"
export * from "./bcsz.vue?vue&type=script&lang=js&"
import style0 from "./bcsz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports